// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"805c6c5d","870":"268d8ca6"}[chunkId] + ".chunk.css";
};